export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative text-white py-16 px-6 mx-6 mb-6 rounded-3xl overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Video Background */}
      <div className="absolute inset-0 rounded-3xl overflow-hidden z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="w-full h-full object-cover opacity-100"
          onError={(e) => {
            console.log('Video failed to load');
            e.currentTarget.style.display = 'none';
          }}
        >
          <source
            src="https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/footer-background-video-luxury-cars-driving-on-modern-highway-at-sunset-with-city-skyline-cinematic-aerial-view.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/70 z-10"></div>
      </div>

      {/* Background Decoration */}
      <div className="absolute bottom-0 left-0 right-0 text-white/10 text-9xl font-bold leading-none select-none pointer-events-none z-20">
        MR. AUTO BROKER
      </div>

      <div className="max-w-7xl mx-auto relative z-30">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand CTA */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/634b5c78b437941165c49867ed9d7e99.jpeg"
                alt="Logo"
                className="h-10 w-10 rounded-full object-cover"
              />
              <div className="text-2xl font-bold">Mr. Auto Broker</div>
            </div>
            <div className="text-sm text-teal-100 mb-8">AI-POWERED CAR BUYING</div>
            <div className="text-xs text-teal-200">Serving Ontario since 2024</div>
            <a 
              href="mailto:izoom@me.com" 
              className="text-xs text-teal-200 hover:text-white transition-colors cursor-pointer mt-2 block"
            >
              izoom@me.com
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <div className="text-sm font-bold uppercase tracking-wider mb-4">NAVIGATE</div>
            <div className="space-y-3">
              {[
                { label: 'How It Works', id: 'how-it-works' },
                { label: 'AI Consultation', id: 'contact' },
                { label: 'Services', id: 'services' },
                { label: 'About', id: 'about' },
                { label: 'Contact Us', id: 'contact' }
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block text-teal-100 hover:text-white transition-colors cursor-pointer text-left"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Social Connect */}
          <div>
            <div className="text-sm font-bold uppercase tracking-wider mb-4">FOLLOW US</div>
            <div className="space-y-3">
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/kevin.schleifer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/kevin-schleifer-0364aa1a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <div className="text-base font-semibold mb-1">Stay updated on car buying tips</div>
            <div className="text-base font-semibold mb-6">& exclusive AI features</div>
            <form className="flex items-center bg-teal-800/50 rounded-full border border-teal-500/30 overflow-hidden">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-3 bg-transparent text-white placeholder-teal-300 focus:outline-none text-sm"
              />
              <button
                type="submit"
                className="w-11 h-11 bg-white rounded-full flex items-center justify-center hover:bg-teal-50 transition-colors cursor-pointer flex-shrink-0 mr-1"
              >
                <i className="ri-arrow-right-line text-xl text-teal-700"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Legal Bar */}
        <div className="pt-8 border-t border-teal-500/30">
          <div className="text-center text-xs text-teal-200">
            © 2025 Mr. Auto Broker • Woodbridge, Ontario • Privacy Policy • Terms •{' '}
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
